import * as React from "react";
import { Product } from "../types";
import classNames from "classnames";
import Img from "../Controls/Img";

declare type OperatorProps = {
    products: Product[],
    selectedProductId: number | undefined;
    onProductChanged: (product: Product) => void;
}
export default class Operator extends React.Component<OperatorProps> {
    renderProduct(p: Product) {
        const isOperatorSelected = this.props.selectedProductId === p.productId;
        try {
            return (
                <div key={p.productId} className="col-6 col-sm-4 col-md-3">
                    <div onClick={e => this.props.onProductChanged(p)}
                        className={classNames(["form-group-small eto-card", isOperatorSelected ? "selected" : ""])}>
                        <div style={{ marginBottom: 5 }}>{p.name}</div>
                        <div style={{ border: "1px solid #ddd", padding: 10, display: "inline-block" }}>
                            <Img src={p.operator.logoUrl} className="operatorlogo" />
                        </div>
                        <div style={{ marginTop: 5 }}>
                            <input type="radio" name="select-product"
                                checked={isOperatorSelected} value={p.productId}
                                onChange={e => this.props.onProductChanged(p)} />
                        </div>
                    </div>
                </div>
            );
        } catch {
            return null;
        }
    }
    render() {
        if (!this.props.products) {
            return null;
        }
        return (
            <React.Fragment>
                <div className="row">
                    {this.props.products.map(p => this.renderProduct(p))}
                </div>
            </React.Fragment>
        );
    }
}
